<template>
  <div class="col-12 d-flex flex-column justify-content-center align-items-center pl-0">
    <!-- LIMITED LIABILITY AGREEMENT INPUT CHECKBOX COMPONENT -->
    <b-form-checkbox
      size="lg"
      :checked="llaStatus"
      :value="true"
      :unchecked-value="false"
      @change="changeHandler"
    >
      <span :style="{ color: textColor }" class="llaText">
        {{ llaStatement }} 
        <a :style="{ color: llaColor }" href="#" @click="displayModalWindow">Limited Liability Agreement (LLA).</a>
      </span>
    </b-form-checkbox>
    <b-form-invalid-feedback :state="llaStatus">
      This Limited Liability Agreement (LLA) MUST be accepted in order to continue
    </b-form-invalid-feedback>

    <!-- LIMITED LIABILITY AGREEMENT MODAL WINDOW DISPLAY -->
    <div v-show="showLLAAgreementStatus" class="modal-window-overlay">
      <div class="modal-window-display">
        <div class="modal-window-body lla-modal-window-body">
          <div class="modal-window-close-container">
            <button 
              type="button" 
              class="modal-window-close-container-button"
              @click="showLLAAgreementStatus = false"
            >
              <i class="mdi mdi-close">
              </i>
            </button>
          </div>
          <div class="container-fluid p-0">
            <div class="lla-modal-container">
              <div class="row m-0 h-100">
                <div style="height: fit-content;" class="col-12 col-lg-3 col-xl-3 d-flex flex-column justify-content-start align-items-center lla-content-gap mt-4">
                  <div class="w-100 modal-window-title-text d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                    <div class="lla-modal-title-text text-center text-lg-left text-xl-left">
                      Limited Liability Agreement
                    </div>
                  </div>
                  <div class="w-100 modal-window-title-text d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
                    <div class="lla-modal-title-text text-center text-lg-left text-xl-left">
                      Terms & Conditions
                    </div>
                  </div>
                </div>
                <div style="min-height: 600px;" class="col-12 col-lg-9 col-xl-9 pl-3 pl-lg-0 pl-xl-0 d-flex flex-column justify-content-center align-items-start lla-content-gap">
                  <div style="min-height: 550px;" class="modal-window-text-content h-100 lla-modal-text-content">
                    <iframe 
                      id="iframe-content"
                      class="lla-content-iframe" 
                      src="https://projectspectrumlearning.io/legal/calla.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                      frameborder="0"
                    >
                    </iframe>
                  </div>
                  <div class="h-auto w-100 d-flex justify-content-center align-items-center">
                    <b-form-checkbox
                      size="lg"
                      :checked="llaStatus"
                      :value="true"
                      :unchecked-value="false"
                      @change="changeHandler"
                    >
                      <span class="text-agreement">I agree to these new terms and conditions</span>
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      llaStatus: Boolean,
      username: String,
      llaColor: {
        type: String,
        default: '#00AFF7',
      },
      textColor: {
        type: String,
        default: '#000000',
      },
      llaAgreementStatusHandler: {
        type: Function,
        default: () => {}
      },
      llaStatement: {
        type: String,
        default: "* By creating an account, you agree to our Limited Liability Agreement (LLA). Please review it before proceeding",
      }
    },
    data() {
      return {
        defaultDisabledTextColor: '#999999',
        defaultDisabledLinkColor: '#7ED9FF',
        showLLAAgreementStatus: false,
      };
    },
    computed: {
      isUsernameProvided() {
        return !this.username && this.username?.length === 0;
      }
    },
    methods: {
      displayModalWindow(event) {
        event.preventDefault();
        this.showLLAAgreementStatus = true;
      },
      changeHandler(statusValue) {
        const llaAgreementStatusValue = statusValue ? `${this.username}-${new Date().toISOString()}-true` : null;
        this.llaAgreementStatusHandler(llaAgreementStatusValue, statusValue);
      }
    },
  }
</script>

<style scoped>
  .llaText {
    font-family: Rajdhani;
    font-size: clamp(14px, 2vw, 18px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  
  a {
    text-decoration: underline !important;
  }

  .lla-modal-window-body {
    height: 100%; 
    border-radius: 20px; 
    position: relative;
  }

  .lla-modal-container {
    margin-top: 50px; 
    height: calc(100% - 60px);
    min-width: 300px;
  }

  .lla-content-gap {
    gap: 30px;
  }

  .text-agreement {
    color: #FFCD00;
    font-family: Rajdhani;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .lla-modal-title-text {
    width: 55%;
  }

  .lla-modal-text-content {
    width: 98%;
    position: relative;
  }

  .lla-content-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>